class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();

    let options = {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      fade: true
    };

    const slider = new Flickity(this, options);

    slider.on("change", (selected_index) => {
      play_and_pause_videos(selected_index);
    });

    document.addEventListener("productgallerythumbnails:click", (event) => {
      slider.select(event.detail.index);
    });

    document.addEventListener("productformvariants:change", (event) => {
      slider.cells.forEach((cell, index) => {
        if (cell.element.dataset.variantId.includes(event.detail.variant.id)) {
          slider.select(index);
        }
      });
    });

    function play_and_pause_videos(selected_index) {
      slider.getCellElements().forEach((element, element_index) => {
        const video = element.querySelector("video");

        if (!video) {
          return;
        }

        if (selected_index == element_index) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
}

customElements.define("product-gallery-slider", ProductGallerySlider);

class ProductGalleryThumbnails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const element = event.target.closest("a");

      document.dispatchEvent(new CustomEvent("productgallerythumbnails:click", {
        detail: {
          index: element.dataset.index
        }
      }));
    });
  }
}

customElements.define("product-gallery-thumbnails", ProductGalleryThumbnails);